/**
 * Configuracion del cliente.
 *
 * Las variables `VITE_*` se resuelven cuando Vite construye el bundle, asi que
 * una imagen construida queda atada al entorno donde se construyo. Para que la
 * misma imagen sirva en desarrollo, en pruebas y en produccion, el contenedor
 * escribe `/config.js` al arrancar (ver `apps/app/docker-entrypoint.sh`) y desde
 * ahi salen estos valores.
 *
 * Orden de preferencia:
 *   1. lo que dejo el contenedor en `window.__TURNPRO__`
 *   2. lo que Vite horneo al construir (desarrollo local con .env.local)
 *   3. los valores de desarrollo por defecto
 *
 * Nada de esto es secreto: todo lo que llega al navegador es publico.
 */

export interface RuntimeConfig {
  readonly apiUrl?: string;
  readonly appUrl?: string;
  readonly landingUrl?: string;
}

declare global {
  interface Window {
    __TURNPRO__?: RuntimeConfig;
  }
}

const runtime: RuntimeConfig = (typeof window !== "undefined" && window.__TURNPRO__) || {};

function resolver(
  enRuntime: string | undefined,
  enBuild: string | undefined,
  porDefecto: string,
): string {
  const valor = enRuntime?.trim() || enBuild?.trim() || porDefecto;
  // Sin barra final: las rutas que se concatenan despues empiezan con "/".
  return valor.replace(/\/+$/, "");
}

/**
 * Base de la API. En produccion es `/api`: Traefik reenvia esa ruta del host
 * de la aplicacion al contenedor de la API, asi el navegador habla con un
 * unico origen y no hay CORS de por medio.
 */
export const API_URL: string = resolver(
  runtime.apiUrl,
  import.meta.env["VITE_API_URL"],
  "http://localhost:3002",
);

export const APP_URL: string = resolver(
  runtime.appUrl,
  import.meta.env["VITE_APP_URL"],
  "http://localhost:3001",
);

export const LANDING_URL: string = resolver(
  runtime.landingUrl,
  import.meta.env["VITE_LANDING_URL"],
  "http://localhost:3000",
);
